import { MATCH_FIELDS } from "./leagueGraphql";

export const TEAM_FIELDS = `
  fragment teamFields on Team {
    _id
    name
    logo
    photo
    gender
    ageGroup
    club
    teamCode
    leagues
  }
`;

export const TEAM_ENRICHED_FIELDS = `
  fragment teamEnrichedFields on TeamEnriched {
   _id
    name
    logo
    photo
    gender
    ageGroup
    club
    teamCode
    leagues
    abbreviation
    linkName
    competitions
  }
`;

export const GET_TEAMS = `
  ${TEAM_ENRICHED_FIELDS}
   query ($clubIds: [String], $term: String, $teamIds: [String], $leagueId: String, $skip: Int, $limit: Int) {
    getTeamsAdmin(clubIds: $clubIds, term: $term, teamIds: $teamIds, leagueId: $leagueId, skip: $skip, limit: $limit) {
      ...teamEnrichedFields
    }
  }
`;

export const GET_TEAMS_MATCHES = `
  ${MATCH_FIELDS}
   query ($teamIds: [String], $fromDate: String, $skip: Int, $limit: Int) {
    getTeamsMatches(teamIds: $teamIds, fromDate: $fromDate, skip: $skip, limit: $limit) {
      ...matchFields
    }
  }
`;

export const CREATE_TEAM = `
  mutation ($team: TeamInput) {
    createTeam(team: $team) {
      _id
    }
  }
`;

export const EDIT_TEAM = `
${TEAM_FIELDS}
  mutation ($teamId: String!, $team: TeamInput) {
    editTeam(teamId: $teamId, team: $team) {
        ...teamFields
    }
  }
`;

export const DELETE_TEAM = `
  mutation ($teamId: String!) {
    deleteTeam(teamId: $teamId)
  }
`;

export const GENERATE_TEAM_CODE = `
  mutation ($teamId: String!) {
    editTeamCode(teamId: $teamId)
  }
`;

// export const ADD_REMOVE_COACH = `
//   ${TEAM_FIELDS}
//   mutation AddRemoveCoach ($teamId: String!, $itemId: String!, $itemType: String!,$remove: Boolean!) {
//     addRemoveCoachToTeam (teamId: $teamId, itemId: $itemId, itemType: $itemType, remove: $remove) {
//       ...teamFields
//     }
//   }
// `;
